import { Component } from '@angular/core';
import Chart from 'chart.js/auto';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { TraineeListService } from '../../service/trainee-list.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConstantConfig } from '../../utility/constant-config';
import { MatSelectChange } from '@angular/material/select';
@Component({
    selector: 'app-dashboard-trainer',
    templateUrl: './dashboard-trainer.component.html',
    styleUrl: './dashboard-trainer.component.scss',
    providers: [DatePipe],
    standalone: false
})
export class DashboardTrainerComponent {
  config: any = ConstantConfig;
  showSidebar: boolean = true;
  test_version: boolean = false;
  test_version1: boolean = true;
  range: FormGroup;
  CustomRange: boolean = false;
  displayValue: string = '';
  dashboardData: any = [];
  RoleplayData: any;
  keys: string[] = [];
  values: number[] = [];
  DailyScore: any;
  Scorekeys: string[] = [];
  Scorevalues: number[] = [];
  DailyCount: any;
  CustomRangeChart: boolean;
  selectedOption: string = 'Abiochat'; // Default option
  selectedTimeframe: string = 'Today'; // Default timeframe
  userRole: string;
  showSessionCount:boolean = false;
  objectKeys = Object.keys;
  labels: unknown[];
  donutChart: Chart<"doughnut", number[], unknown>;
  selectedPie: string;
  selectedPieValue: string = 'Today';
  constructor(private fb: FormBuilder, private datePipe: DatePipe, private Router: Router,  
    public TraineeService: TraineeListService, private snackBar: MatSnackBar) {
    this.range = this.fb.group({
      start: [null],
      end: [null]
    });

    this.range.valueChanges.subscribe(val => {
      if (val.start && val.end) {
        const start = this.datePipe.transform(val.start, 'MM/dd/yyyy');
        const end = this.datePipe.transform(val.end, 'MM/dd/yyyy');
        if (val.start > val.end) {
          this.snackBar.open('Please select a end date greater than start date', 'Close', {
            duration: 3000, // Duration in milliseconds
            verticalPosition: 'top' // Adjust as per your layout
          });
        }
        this.displayValue = `${start} To ${end}`;
      } else {
        this.displayValue = '';
      }
    });
  }

  ngOnInit(): void {
    this.setRole();
    if(this.userRole === 'Trainer' ){
    this.TraineeService.getDashboardTraineeSummary("Today").subscribe(res => {
      this.dashboardData = res;
    });
  }
  this.fetchAvatarUsageByDate(this.selectedTimeframe,this.selectedOption);
    //this.fetchData(this.selectedOption, this.selectedTimeframe);
    this.fetchPieChartData(this.selectedPieValue);
   // this.fetchAvatarUsage();
  }
  fromDate(event) {
    // console.log("From", event.value)
  }
  setRole() {
    let ROLE: string = sessionStorage.getItem('role');
    if (ROLE) {
      if (ROLE === 'TRAINER') {
        this.userRole = 'Trainer';
      } else if (ROLE === 'SUPERVISOR') {
        this.userRole = 'Supervisor';
      } else {
        this.userRole = 'Trainee';
      }
    } 
  }

  toDate(event) {
   //  console.log("To", event.value)
  }

optionSelected(event){
  if(event.value == "Custom Date Range"){
    this.CustomRange = true;
  }else{
    this.CustomRange = false;
  }
  if(event.value != "Custom Date Range")
    this.TraineeService.getDashboardTraineeSummary(event.value).subscribe(res=>{
      this.dashboardData = res;
    });
}
optionSelectedChart(event){
  if(event.valueChart == "Custom Date Range"){
    this.CustomRangeChart = true;
  }else{
    this.CustomRangeChart = false;
  }
  if(event.value != "Custom Date Range"){}
   
}
quiz(){
  this.test_version = true;
}
roleplay(){
  this.test_version = false;
}
avatar() {
  this.test_version1 = true;
  this.fetchRoleplayUsageByDate(this.selectedTimeframe);
}

fetchAvatarUsage() {
  this.TraineeService.getDashboardAvatarUSage().subscribe(res => {
    this.DailyCount = res; 
    this.createAvatarCountChart();
  }, error => {
    console.error('Error fetching avatar usage:', error);
  });
}
onTimeframeChange(selectedValue: string) {
  this.selectedTimeframe = selectedValue;
  this.fetchData(this.selectedOption, this.selectedTimeframe);
}
fetchPieChartData (value: string){
  this.selectedPieValue= value;
  this.TraineeService.getDashboardRoleplays(this.selectedPieValue).subscribe(res => {
    const loggedInUsersCount = res.LoggedInUsersCount;
    this.labels = [];
  this.values = [];
  Object.keys(loggedInUsersCount).forEach(key => {
    const formattedDate = this.formatDateToUS(key);  
    this.labels.push(formattedDate);  
    this.values.push(loggedInUsersCount[key]);  
  });
    this.createDonutChart();
  });
}
onFramePieChart(event: MatSelectChange): void {
  
  this.selectedPieValue = event.value;
  this.fetchPieChartData(this.selectedPieValue);

}
selectOption(option: string) {
  this.selectedOption = option;
    this.test_version1 = option === 'avatar';
  this.fetchData(this.selectedOption, this.selectedTimeframe);
}
fetchData(option: string, timeframe: string) {
  let chatTopic = '';
  if (option === 'Summarizer') {
    chatTopic = 'Summarizer';  
  }
  this.fetchAvatarUsageByDate(timeframe, option, chatTopic);
}

fetchAvatarUsageByDate(timeframe: string, option?: string, chatTopic?: string) {
  if (chatTopic) {
    this.TraineeService.getDashboardAvatarUSageData(timeframe, '', chatTopic).subscribe(res => {
      this.DailyCount = res; 
      this.createAvatarCountChart();
    }, error => {
      console.error('Error fetching avatar usage:', error);
    });
  } else {
    this.TraineeService.getDashboardAvatarUSageData(timeframe, option, '').subscribe(res => {
      this.DailyCount = res; 
      this.createAvatarCountChart();
    }, error => {
      console.error('Error fetching avatar usage:', error);
    });
  }
}
fetchRoleplay(){
  this.TraineeService.getDashboardDailyscore().subscribe(res => {
      this.DailyScore = res;
      this.Scorekeys = [];
      this.Scorevalues = [];
        this.Scorekeys = Object.keys(this.DailyScore);
        this.Scorevalues = Object.values(this.DailyScore);
        this.createLineChart();
    });
}
fetchRoleplayUsageByDate(timeframe:string){
  this.TraineeService.getDashboardRoleplaysByDate(timeframe).subscribe(res => {
    this.DailyScore = res;
    this.Scorekeys = [];
    this.Scorevalues = [];
      this.Scorekeys = Object.keys(this.DailyScore);
      this.Scorevalues = Object.values(this.DailyScore);
      this.createLineChart();
  })
}
createAvatarCountChart() {
  const ctx = <HTMLCanvasElement>document.getElementById('lineChart');
  if (Chart.getChart(ctx)) {
    Chart.getChart(ctx).destroy(); 
  }
  if (this.DailyCount && this.DailyCount.Count) {
    const formattedLabels = Object.keys(this.DailyCount.Count).map(dateStr => {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US'); 
    }); 
    const lineChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: formattedLabels,
        datasets: [{
          label: 'Count',
          data: Object.values(this.DailyCount.Count),
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
          fill: false
        }]
      },
      options: {
        scales: {
          y: {
            suggestedMin: 0,
            suggestedMax: 100,
            ticks: {
              stepSize: 10
            }
          }
        },
        plugins: {
          legend: {
            display: false
          }
        }
      }
    });
  } else {
    console.error('DailyCount or DailyCount.Count is not defined');
  }
  
}
routtonew(){
  this.Router.navigate(['/app-avatar-metrics'], { skipLocationChange: true });
  
}
count() {
  this.test_version1 = false;
  this.fetchRoleplay();
}

getStyle(index: number) {
  const colors = ['red', 'blue', 'gray', 'orange', 'purple', 'green', 'pink','black', 'purple'];
  return {
    'background-color': colors[index % colors.length]
  };
}
createDonutChart(): void {
  if (this.donutChart) {
    this.donutChart.destroy(); 
  }
  this.donutChart = new Chart('donutChart', {
    type: 'doughnut',
    data: {
      labels: this.labels, 
      datasets: [{
        label: '',  
        data: this.values, 
        backgroundColor: ['red', 'blue', 'green', 'orange', 'purple', 'pink', 'yellow', 'gray', 'brown'],  // Customize colors
        hoverOffset: 4
      }]
    },
    options: {
      responsive: true,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: (tooltipItem) => {
              const rawDate = tooltipItem.label
              const count = tooltipItem.raw;  
              const formattedDate: string = this.formatDateToUS(rawDate);
              return `${count} users`;
            }
          }
        }
      }
    }
  });
}
formatDateToUS(dateStr: string): string {
  const date = new Date(dateStr); 
  const month: string = String(date.getMonth() + 1).padStart(2, '0');  
  const day: string = String(date.getDate()).padStart(2, '0');  
  const year: number = date.getFullYear();  
  return `${month}/${day}/${year}`; 
}


createLineChart() {
var ctx = <HTMLCanvasElement>document.getElementById('lineChart');
if (Chart.getChart(ctx)) {
  Chart.getChart(ctx).destroy(); // Destroy the existing chart instance
}
var lineChart = new Chart(ctx, {
  type: 'line',
  data: {
    labels: Object.keys(this.DailyScore.Count).map(dateStr => {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US'); 
    }),

    datasets: [{
      label: 'Count',
      data: Object.values(this.DailyScore.Count), 
      borderColor: 'rgba(54, 162, 235, 1)', 
      borderWidth: 1,
      fill: false 
    }]
  },
  options: {
    scales: {
      y: {
        suggestedMin: 0,
        suggestedMax: 100,
        ticks: {
          stepSize: 10
        }
      }
    },
    plugins: {
      legend: {
        display: false
      }
    }
  }
});

  // const lineChart = new Chart('lineChart', {
  //     type: 'line',
  //     data: {
  //         labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  //         datasets: [{
  //             label: 'AbioRoleplay',
  //             data: [0, 59, 80, 81, 86, 95, 100],
  //             borderColor: 'purple',
  //             fill: false
  //         },
  //         {
  //           label: 'AbioChat focus',
  //           data: [0, 29, 32, 41, 36, 78, 80],
  //           borderColor: 'blue',
  //           fill: false
  //       }]
  //     },
  //     options: {
  //         responsive: true,
  //         scales: {
  //             y: {
  //                 beginAtZero: true
  //             }
  //         }
  //     }
  // });
}  
menuHandler() {
    this.showSidebar = !this.showSidebar;
  }

  trainelist()
  {
    this.Router.navigate(['/app-trainee-list'], { skipLocationChange: true });
  }
}
